export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13460.0229e952.jpg";